import React from 'react';
export function FooterSection() {
  return <footer className="bg-gray-900 text-gray-400 py-8 px-4 text-center text-sm border-t border-gray-800" data-id="element-116">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-117">
        <p className="text-blue-400 font-bold mb-2" data-id="element-118">
          💙 "The best investment you can make is in your child's developing
          brain."
        </p>
        <p data-id="element-119">💙 THE LITTLE GENIUS SYSTEM™ — © 2026 — All rights reserved.</p>
        <p className="text-xs text-gray-500" data-id="element-120">
          Reproduction and redistribution prohibited without express
          authorization.
        </p>
        <div className="flex justify-center gap-4 pt-2" data-id="element-121">
          <a href="#" className="hover:text-white transition-colors" data-id="element-122">
            Privacy Policy
          </a>
          <span data-id="element-123">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-124">
            Terms & Conditions
          </a>
        </div>
      </div>
    </footer>;
}